import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
  selector: "app-fullscreen-loader",
  imports: [],
  templateUrl: "./fullscreen-loader.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: "./fullscreen-loader.component.scss"
})
export class FullscreenLoaderComponent {
  message = input.required<string>();
  subMessage = input<string | null>(null);
}
